import { IChallengeCardSimpleBase } from "@Components/game/challenges/cards/challenge-card-simple";
import { HorizontalScroller } from "@Components/game/common/horizontal-scroller";
import PlaylistCard from "@Components/game/playlists/common/cards/playlist-card";
import { PlaylistRowStack } from "@Components/game/playlists/highlighted/cards/styled-components";
import { GetPlaylistsRequest, PlaylistResponse } from "@Shared/schemas/playlists/playlistSchemas";
import { Skeleton, Stack, useTheme } from "@mui/material";
import { SwiperSlide } from "swiper/react";

interface IPlaylistRow extends IChallengeCardSimpleBase {
  tag?: string;
  limit?: number;
  filters?: GetPlaylistsRequest["filters"];
  orderBy?: GetPlaylistsRequest["order_by"];
  overflow?: boolean;
  playlists?: PlaylistResponse[];
  loading?: boolean;
}

const PlaylistRow = ({ size, limit, filters = {}, overflow = true, playlists, loading }: IPlaylistRow) => {
  const theme = useTheme();

  if (loading) {
    return (
      <Stack spacing={3}>
        <HorizontalScroller padding={theme.spacing(6)}>
          {[...Array(4)].map((_, index) => (
            <SwiperSlide key={index} style={{ width: "auto", marginLeft: theme.spacing(6) }}>
              <Stack spacing={2}>
                <Skeleton
                  variant="rounded"
                  height={size === "medium" ? 244 : 180}
                  width={size === "medium" ? 432 : 318}
                  sx={{ borderRadius: theme.spacing(3) }}
                />
                <Stack spacing={0.5}>
                  <Skeleton variant="text" height={32} width={250} />
                  <Skeleton variant="text" height={24} width={150} />
                </Stack>
              </Stack>
            </SwiperSlide>
          ))}
        </HorizontalScroller>
      </Stack>
    );
  }

  if (!playlists?.length) return null;

  const playlists_ = limit ? playlists.slice(0, limit) : playlists;

  return overflow ? (
    <HorizontalScroller padding={theme.spacing(6)} initialSlide={0}>
      {playlists_.map((playlist, index) => (
        <SwiperSlide key={playlist.id} style={{ width: "auto", marginLeft: theme.spacing(index === 0 ? 6 : 3) }}>
          <PlaylistCard playlist={playlist} size={size} />
        </SwiperSlide>
      ))}
    </HorizontalScroller>
  ) : (
    <PlaylistRowStack direction="row" spacing={3}>
      {playlists_.map((playlist) => (
        <PlaylistCard key={playlist.id} playlist={playlist} fullWidth={!overflow} />
      ))}
    </PlaylistRowStack>
  );
};
export default PlaylistRow;
